<template>
  <div>
    <div class="logo">
      <h1>
        <a href="https://kimbutech.com" title="Kimbu Tech">
          <img src="@/assets/images/kimbutech_logo.svg" alt="Kimbu Tech" />
        </a>
      </h1>
    </div>

    <div class="supportContainer">
      <div class="container">
        <div class="row">
          <div class="col-12">
            <div class="form-header">
              <h2>Support Us</h2>
              <p>
                Please complete the following information to make the payment
                for IT development resource as per invoice
              </p>
            </div>
            <div class="paymentForm">
              <PaymentForm />
            </div>
            <div class="form-footer">
              <p>
                By clicking on Submit, you will be redirected to a payment page
              </p>
              <img
                src="@/assets/images/payment_gateway.png"
                alt="Payment Gateway"
                class="img-fluid"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const PaymentForm = () => import("@/components/forms/PaymentForm.vue");
export default {
  name: "Home",
  components: {
    PaymentForm,
  },
};
</script>

<style lang="sass">
@import "@/assets/sass/style.sass";

.logo

    img
        height: 150px;

.supportContainer
    padding: 32px 72px;
    border: 1px solid $light_blue;
    border-radius: 4px;
    max-width: 770px;
    display: block;
    margin: 20px auto 40px;

    .form-header
        margin-bottom: 35px;
        padding: 0 30px;

        h2
            font-size: 32px;
            font-weight: 700;
            margin-bottom: 22px;

        p
            font-size: 14px;
            line-height: 20px;
            max-width: 522px;
            margin: 0 auto;

    .form-footer
        margin-bottom: 35px;
        padding: 0 30px;

    .paymentForm
        margin-bottom: 1rem;

@media only screen and (max-width: 767px)
  .supportContainer
    padding: 32px 30px;
    margin: 20px 30px 40px;
</style>
